
import { useState } from 'react';

export default function Newsletter() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'What is UGC and why do brands need it?',
      answer: 'UGC (User-Generated Content) is authentic content created by real people rather than professional studios. It performs better in ads because it feels genuine and relatable, leading to higher engagement and conversion rates.'
    },
    {
      question: 'What\'s your turnaround time?',
      answer: 'Standard turnaround is 5-7 business days depending on the package. Rush delivery is available for an additional fee. I\'ll always communicate clear timelines before we start.'
    },
    {
      question: 'Do you offer usage rights?',
      answer: 'Yes! All packages include usage rights for paid ads and organic social media. Extended licensing for TV, OOH, or other channels can be discussed separately.'
    },
    {
      question: 'What niches do you work with?',
      answer: 'I specialize in beauty, skincare, tech, fashion, and lifestyle brands. If your product fits my audience and aesthetic, I\'d love to chat about a collaboration.'
    },
    {
      question: 'How does the process work?',
      answer: 'It\'s simple: 1) You send me your product and brief, 2) I create the content within the agreed timeline, 3) You review and request revisions if needed, 4) Final delivery with all files and raw footage.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <div className="text-xs uppercase tracking-widest text-amber-700 mb-3 md:mb-4">FAQ</div>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900">
            Common <span className="font-light italic">Questions</span>
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-stone-50 rounded-xl md:rounded-2xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="font-medium text-stone-900 text-sm md:text-base pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-lg md:text-xl text-stone-500 transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-60' : 'max-h-0'
              }`}>
                <p className="px-4 md:px-6 pb-4 md:pb-5 text-sm md:text-base text-stone-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
